import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";


document.querySelectorAll('input[type="date"]').forEach(el => {
  flatpickr(el, {});
});

const checkFieldValidity = (args) => {
  const collapseQuery = document.querySelectorAll("#application-form .collapse");
  const invalidHeaderCheckQuery = document.querySelectorAll("#application-form .invalid-header-check");

  invalidHeaderCheckQuery.forEach(invalidHeaderCheckEl => {
    invalidHeaderCheckEl.remove();
  });

  let totalInvalidInputs = 0;
  collapseQuery.forEach(collapseEl => {
    const inputQuery = collapseEl.querySelectorAll("input");
    let invalidInputs = 0;
    inputQuery.forEach(input => {
      if (input.checkValidity() === false) {
        invalidInputs++;
        totalInvalidInputs++;
      }

      if (args.firstRun) {
        input.addEventListener("change", () => {
          checkFieldValidity({firstRun: false});
        });
      }
    });

    const collapseHeader = collapseEl.parentElement.querySelector(".card-header h5");

    // if the collapseHeader contains the text "Credit or Debit Card" then assume it's invalid
    if (collapseHeader && collapseHeader.textContent.includes("Credit or Debit Card") && args.firstRun === true) {
      invalidInputs++;
      totalInvalidInputs++;
    }

    if (collapseHeader && invalidInputs > 0) {
      const invalidDiv = document.createElement("div");
      invalidDiv.classList.add("invalid-header-check", "float-right", "d-inline", "text-danger", "font-weight-bold");
      invalidDiv.textContent = `${invalidInputs} Invalid or Required Fields`;
      collapseHeader.appendChild(invalidDiv);
    }

    const totalInvalidInputsEl = document.querySelector("#total-invalid-inputs");
    totalInvalidInputsEl.textContent = `${totalInvalidInputs} Invalid or Required Fields in the sections above.`;
  });
};

checkFieldValidity({firstRun: true});
